module.exports = __webpack_public_path__ + "img/wheel.fbf3463a.png";